import { createDeferred } from '../../utils/promise/defer';
import { extractCancelAndProgressConfig, isAborted as _isAborted } from '../../utils/http';
import { UploadStatus } from '../../constants/upload-status';
import Cancel from 'axios/lib/cancel/Cancel';
import { generateRandomGuid4 } from '../../utils/utils';

function promisify(value) {
  if (value.then) {
    return value;
  }

  return Promise.resolve(value);
}

var _canAbort = function canAbort(fileToUpload) {
  return fileToUpload.status === UploadStatus.Waiting || fileToUpload.status === UploadStatus.Uploading;
};

function abortEarly(fileToUpload) {
  fileToUpload.deferred.promise["catch"](function (reason) {
    fileToUpload.failedOnStage = fileToUpload.status;
    fileToUpload.status = UploadStatus.Failed;
    fileToUpload.error = reason;
  });
  fileToUpload.deferred.reject(new Cancel('aborted early by user'));
}

function initUpload(fileToUpload, data) {
  fileToUpload.status = UploadStatus.Uploading;
  var uploadFnValue = data.uploadFn(fileToUpload.source, fileToUpload.options, fileToUpload.cancelAndProgressConfig);
  var uploadFnPromise = promisify(uploadFnValue);
  fileToUpload.uploadPromise = uploadFnPromise.then(function (res) {
    fileToUpload.deferred.resolve(res);
  })["catch"](function (reason) {
    fileToUpload.failedOnStage = fileToUpload.status;
    fileToUpload.status = UploadStatus.Failed;
    fileToUpload.error = reason;
    fileToUpload.deferred.reject(reason);
  });
}

export function toFileToUpload(data) {
  return {
    id: generateRandomGuid4(),
    adapter: data.adapter || {},
    source: data.source,
    options: data.options,
    status: UploadStatus.Waiting,
    canReportStatusChange: true,
    cancelAndProgressConfig: extractCancelAndProgressConfig(),
    bytesLoaded: 0,
    currentChunkBytesLoaded: 0,
    deferred: createDeferred(),
    setCanReportStatusChange: function setCanReportStatusChange(canReportStatusChange) {
      this.canReportStatusChange = canReportStatusChange;
    },
    isAborted: function isAborted() {
      return _isAborted(this.error);
    },
    error: {},
    upload: function upload() {
      if (!this.isAborted()) {
        initUpload(this, data);
      }

      return this.uploadPromise;
    },
    abort: function abort() {
      if (!_canAbort(this)) {
        return;
      }

      if (this.status === UploadStatus.Waiting) {
        abortEarly(this);
        return;
      }

      this.cancelAndProgressConfig.abort();
    },
    canRetry: function canRetry() {
      if (this.isAborted()) {
        return true;
      }

      var codesToRetry = [-201, 401, 403, 408];
      return this.status === UploadStatus.Failed && codesToRetry.indexOf(this.error.code) !== -1;
    },
    signUpForRetry: function signUpForRetry() {
      this.status = UploadStatus.Waiting;
      this.error = {};
      this.cancelAndProgressConfig = extractCancelAndProgressConfig();
      this.deferred = createDeferred();
    },
    canAbort: function canAbort() {
      return _canAbort(this);
    },
    getFileSize: function getFileSize() {
      return this.source.file ? this.source.file.size : 1;
    }
  };
}